import React, { useState, useEffect, createContext, FormEvent } from 'react';
import './App.css';
import { PATH_DRAFT_CONDITION_SETTING, PATH_ORIGINSETTING, PATH_PLANRESULT, PATH_ROOT } from './constants/const';
import SidePanel from './components/sidePanel';
import HeaderPanel from './components/headerPanel';
import PageDraftConditionSetting from './pages/pageDraftConditionSetting';
import PageLogin from './pages/pageLogin';
import PageOriginSetting from './pages/pageOriginSetting';
import PagePlanResult from './pages/pagePlanResult';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useApi, REQ_API_LOGIN, JsonResponse } from './logic/classApi';
import { LoginService } from './logic/loginService';
import ReactDOM from 'react-dom/client';
import AppPane from './components/appPane';

/** ダイアログ表示待機中にこのエラーが発生した場合はメッセージとして表示する */
export class ShownError extends Error {}

interface LoginContextType {
  isLogin: boolean;
  setIsLogin: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LoginContext = createContext<LoginContextType>({ isLogin: false, setIsLogin: () => {} });

const NotFound = () => <h1>404 - Page Not Found</h1>;

function App() {
  const [isApiLoading, setApiLoading] = useState(false);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const isUnsavedState = useState(false);
  const [isUnsaved, setIsUnsaved] = isUnsavedState;

  const { postRequestJson } = useApi();

  // ログイン
  useEffect(() => {
    (async () => {
      const strageinfo = LoginService.getLoginInfo();
      if (
        strageinfo.sessionId !== '' &&
        (strageinfo.screenUrl === PATH_PLANRESULT || strageinfo.screenUrl === PATH_ORIGINSETTING || strageinfo.screenUrl === PATH_DRAFT_CONDITION_SETTING)
      ) {
        try {
          const requestUrl = `${REQ_API_LOGIN}?userId=${strageinfo.userId}`;
          const { payload: response } = await postRequestJson<JsonResponse>(requestUrl, { userId: strageinfo.userId });
          if (response.session_id !== '') {
            window.history.pushState({}, '', strageinfo.screenUrl);
            setIsLogin(true);
          } else {
            redirectTop();
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        redirectTop();
      }
      setApiLoading(true);
    })();
  }, []);

  const loginContext = { isLogin, setIsLogin };

  const toggleSidePanel = () => {
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  const redirectTop = () => {
    window.history.pushState({}, '', PATH_ROOT);
  };

  const redirect = () => {
    window.history.pushState({}, '', PATH_PLANRESULT);
  };

  const sideOpenStyle: React.CSSProperties = {
    position: 'sticky',
    display: 'grid',
    gridTemplateColumns: '200px 1fr',
  };

  const sideCloseStyle: React.CSSProperties = {
    position: 'sticky',
    display: 'grid',
    gridTemplateColumns: '40px 1fr',
  };

  const headerStyle: React.CSSProperties = {
    position: 'relative',
    zIndex: 500,
  };

  const pagePanelOpenStyle: React.CSSProperties = {
    backgroundColor: 'var(--color-lightgray)',
    width: 'calc(100vw - 200px)',
    height: 'calc(100vh - 60px)',
    overflowX: 'hidden',
  };
  const pagePanelCloseStyle: React.CSSProperties = {
    backgroundColor: 'var(--color-lightgray)',
    width: 'calc(100vw - 40px)',
    height: 'calc(100vh - 60px)',
    overflowX: 'hidden',
  };

  const loginStyle: React.CSSProperties = {
    display: 'grid',
    width: '100vw',
    height: '100vh',
  };
  if (!isApiLoading) {
    return <div style={{ backgroundColor: 'white', height: '100vh' }}></div>;
  }
  return (
    <AppPane>
      <LoginContext.Provider value={loginContext}>
        {isLogin ? ( //login成功後画面を表示
          <Router>
            <div>
              <div style={headerStyle}>
                <HeaderPanel invokeHandle={setIsLogin} />
              </div>
              <div style={isSidePanelOpen ? sideOpenStyle : sideCloseStyle}>
                <SidePanel isOpen={isSidePanelOpen} onClose={toggleSidePanel} isUnsavedState={isUnsavedState} />
                <div style={isSidePanelOpen ? pagePanelOpenStyle : pagePanelCloseStyle}>
                  <Routes>
                    <Route path={PATH_PLANRESULT} element={<PagePlanResult isUnsavedState={isUnsavedState} />} />
                    <Route path={PATH_ORIGINSETTING} element={<PageOriginSetting />} />
                    <Route path={PATH_DRAFT_CONDITION_SETTING} element={<PageDraftConditionSetting />} />
                    <Route path={PATH_ORIGINSETTING} element={<PageOriginSetting />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </div>
              </div>
            </div>
          </Router>
        ) : (
          <div style={loginStyle}>
            <PageLogin onClick={setIsLogin} redirect={redirect} />
          </div>
        )}
      </LoginContext.Provider>
    </AppPane>
  );
}

export const openNewTabComponent = async (NewTabComponent: JSX.Element, newWindowRef: React.MutableRefObject<Window | null>) => {
  const newWindow = window.open('', '_blank', 'width=1350,height=1200');

  (window as any).subWindow = newWindow;

  if (newWindow) {
    newWindow.document.write(`
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>PastResult</title>
        <!-- Bootstrap の読み込み -->
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-9ndCyUaIbzAi2FUVXJi0CjmCapSmO7SnpJef0486qhLnuZ2cdeRhO02iuK6FUUVM" crossorigin="anonymous">
      </head>
      <body>
        <div id="new-tab-root"></div>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-geWF76RCwLtnZ8qwWowPQNguL3RmwHVBC9FhGdlKrxdiJJigb/j/68SIy3Te4Bkz" crossorigin="anonymous">          
          // このスクリプトタグの中でReactとReactDOMをインポート
          const root = document.getElementById('new-tab-root');
          window.React = React;
          window.ReactDOM = ReactDOM;
          ReactDOM.render(React.createElement(${NewTabComponent}), root);
        </script>
      </body>
      </html>
    `);
    newWindow.document.close();
    const rootElement = newWindow?.document.getElementById('new-tab-root');
    if (rootElement) {
      const root = ReactDOM.createRoot(rootElement);
      root.render(NewTabComponent);

      newWindow.onbeforeunload = () => {
        root.unmount(); // コンポーネントをアンマウント
        newWindowRef.current = null;
      };
    }

    newWindowRef.current = newWindow;

    const interval = setInterval(() => {
      if (newWindow?.closed) {
        clearInterval(interval);
        // ウィンドウが閉じられたらクリーンアップ
        newWindowRef.current = null; // 参照を解除
      }
    }, 1000);
  }
};

export default App;
